import DefaultActivityTypeName from "@mapmycustomers/shared/enum/activity/DefaultActivityTypeName";
import { ActivityTypeRef } from "@mapmycustomers/shared/types/entity/activities/ActivityType";

// Zoho Calls and Tasks hold one person on Who_Id, so a sync keeps only the primary contact and
// silently drops the rest. Zoho Events carry several people and are unaffected.
// Matched on name because MMC activity types carry no CRM module mapping: a renamed, translated
// or custom type will not match. mmc-react-native hardcodes the same list — edit both together.
const ZOHO_SINGLE_PERSON_ACTIVITY_TYPE_NAMES = new Set(
  [DefaultActivityTypeName.CALL, DefaultActivityTypeName.TASK].map((name) => name.toLowerCase())
);

export const isZohoSinglePersonActivityType = (activityType?: ActivityTypeRef): boolean =>
  !!activityType &&
  ZOHO_SINGLE_PERSON_ACTIVITY_TYPE_NAMES.has(activityType.name.trim().toLowerCase());

const shouldWarnZohoKeepsPrimaryContactOnly = (
  isZohoOrganization: boolean,
  activityType: ActivityTypeRef | undefined,
  peopleCount: number
): boolean => isZohoOrganization && peopleCount > 1 && isZohoSinglePersonActivityType(activityType);

export default shouldWarnZohoKeepsPrimaryContactOnly;
